module.exports = __webpack_public_path__ + "img/app-4.36fae2a0.webp";